/* tslint:disable */
/* eslint-disable */
/**
 * external-information-requests
 * Medicaid Pending document requests to family members, with the staff workspace and the family portal
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ReadCursor } from './ReadCursor';
import {
    ReadCursorFromJSON,
    ReadCursorFromJSONTyped,
    ReadCursorToJSON,
    ReadCursorToJSONTyped,
} from './ReadCursor';

/**
 * 
 * @export
 * @interface ReadCursorResponse
 */
export interface ReadCursorResponse {
    /**
     * 
     */
    data: ReadCursor;
}

/**
 * Check if a given object implements the ReadCursorResponse interface.
 */
export function instanceOfReadCursorResponse(value: object): value is ReadCursorResponse {
    if (!('data' in value) || value['data'] === undefined) return false;
    return true;
}

export function ReadCursorResponseFromJSON(json: any): ReadCursorResponse {
    return ReadCursorResponseFromJSONTyped(json, false);
}

export function ReadCursorResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReadCursorResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': ReadCursorFromJSON(json['data']),
    };
}

export function ReadCursorResponseToJSON(json: any): ReadCursorResponse {
    return ReadCursorResponseToJSONTyped(json, false);
}

export function ReadCursorResponseToJSONTyped(value?: ReadCursorResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': ReadCursorToJSON(value['data']),
    };
}

